import { styled } from '@/stitches.config';
import { CardVariants } from './Card.types';

export const StyledCard = styled('div', {
  borderRadius: '$3',
  padding: '$4',
  variants: {
    variant: {
      [CardVariants.PRIMARY]: {
        boxShadow: '$card',
      },
      [CardVariants.SECONDARY]: {
        boxShadow: 'none',
        border: '1px solid $colors$seafoam400',
        background: '$seafoam800',
      },
      [CardVariants.TERTIARY]: {
        boxShadow: 'none',
        border: '1px solid $colors$seafoam400',
      },
    },
  },
});
